import React from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { KeyIcon, TrendingUpIcon } from 'lucide-react';
export function SecretSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.1);
  return <section className="py-20 md:py-32 bg-[#020202] relative overflow-hidden" data-id="element-269">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-purple-900/10 blur-[120px] rounded-full pointer-events-none" data-id="element-270" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-271">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-272">
          <div className="inline-flex items-center gap-2 bg-purple-500/10 border border-purple-500/20 text-purple-400 px-4 py-2 rounded-full text-sm font-bold mb-8" data-id="element-273">
            <KeyIcon className="w-4 h-4" data-id="element-274" />
            <span data-id="element-275">La cruda verdad</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-extrabold mb-8 tracking-tight text-white" data-id="element-276">
            El secreto de los que más venden
          </h2>
          <p className="text-2xl md:text-3xl text-gray-300 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-277">
            Los que más venden testean creativos nuevos{' '}
            <span className="text-purple-400 font-bold" data-id="element-278">TODO EL TIEMPO.</span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-279">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="glass-card p-8 md:p-10 rounded-3xl border border-white/5 bg-white/[0.02]" data-id="element-280">
            <h3 className="text-xl font-bold text-gray-400 mb-4 uppercase tracking-wider text-sm" data-id="element-281">
              Tu realidad actual
            </h3>
            <p className="text-2xl text-white font-medium leading-relaxed" data-id="element-282">
              Mientras vos tardás{' '}
              <span className="text-red-400 font-bold" data-id="element-283">3 horas</span> en un
              creativo...
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="glass-card p-8 md:p-10 rounded-3xl border-2 border-purple-500/30 bg-purple-900/10 relative overflow-hidden" data-id="element-284">
            <div className="absolute -right-4 -bottom-4 opacity-10" data-id="element-285">
              <TrendingUpIcon className="w-48 h-48 text-purple-500" data-id="element-286" />
            </div>
            <h3 className="text-xl font-bold text-purple-400 mb-4 uppercase tracking-wider text-sm relative z-10" data-id="element-287">
              La competencia
            </h3>
            <p className="text-2xl text-white font-medium leading-relaxed relative z-10" data-id="element-288">
              Tu competencia ya lanzó{' '}
              <span className="text-green-400 font-bold" data-id="element-289">20 creativos</span>{' '}
              nuevos al mercado.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.6,
        duration: 0.5
      }} className="text-center max-w-3xl mx-auto" data-id="element-290">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-291">
            Con <span className="text-white font-bold" data-id="element-292">100ads</span>, vas a
            tener acceso al secreto mejor guardado de los que más facturan:{' '}
            <span className="text-purple-400 font-bold" data-id="element-293">
              VOLUMEN de creativos + testeo constante.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}